class StateStorage {

  entity = '';

  constructor(entity) {
    this.entity = entity;
  }

  parseAndReturnState() {
    const globalStates = JSON.parse(localStorage.getItem('globalStates'));
    if (globalStates) {
      return globalStates[this.entity];
    }
    return null;
  }

  stringifyAndStoreState(tableState) {
    let globalStates = {};
    if (localStorage.getItem('globalStates')) {
      globalStates = JSON.parse(localStorage.getItem('globalStates'));
    }
    globalStates[this.entity] = tableState;
    localStorage.setItem('globalStates', JSON.stringify(globalStates));
  }

  static set(name, item) {
    localStorage.setItem(name, JSON.stringify(item));
  }

  static get(name) {
    return JSON.parse(localStorage.getItem(name));
  }

}

export default StateStorage;



// WEBPACK FOOTER //
// ./src/utils/StateStorage.js